class ViewSwitcher {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._viewSwitchers = this._elem.querySelectorAll('[data-view-switcher]')
        this._viewSwitcherGrids = this._elem.querySelectorAll('[data-view-switcher-grid]')
    }

    onInit () {
        for (let switcher of this._viewSwitchers) {
            switcher.addEventListener('click', e => {
                e.preventDefault()
                localStorage.setItem('ESC-VIEW-BY', switcher.dataset.viewSwitcher)
                this.checkViewBy()
            })
        }
        this.checkViewBy()
    }

    checkViewBy () {
        let viewBy = localStorage.getItem('ESC-VIEW-BY')
        if (viewBy === null) return

        for (let otherSwitcher of this._viewSwitchers) {
            otherSwitcher.classList.remove('active')
            if (otherSwitcher.dataset.viewSwitcher === viewBy) {
                otherSwitcher.classList.add('active')
            }
            for (let grid of this._viewSwitcherGrids) {
                grid.classList.remove(otherSwitcher.dataset.viewSwitcher)
            }
        }
        for (let grid of this._viewSwitcherGrids) {
            grid.classList.add(viewBy)
        }
    }
}

export default ViewSwitcher



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ViewSwitcher.js